import { Box, Button, Stack, useTheme } from "@mui/material";
import type { FormEventHandler, ReactNode } from "react";

type Props = {
	onSubmit: FormEventHandler<HTMLFormElement>;
	submitLabel: string;
	disabled?: boolean;
	loading?: boolean;
	children: ReactNode;
};

export const PortfolioFormShell = ({
	onSubmit,
	submitLabel,
	disabled,
	loading,
	children,
}: Props) => {
	const theme = useTheme();

	return (
		<Stack
			component="form"
			onSubmit={onSubmit}
			minHeight="100%"
			bgcolor={theme.palette.grey[50]}
		>
			{children}

			<Box
				px={theme.spacingTokens.lg}
				pt={theme.spacingTokens.xl}
				pb={theme.spacingTokens.xxl}
			>
				<Button
					type="submit"
					variant="primary"
					disabled={disabled}
					loading={loading}
				>
					{submitLabel}
				</Button>
			</Box>
		</Stack>
	);
};
